import { FC, useMemo, useRef } from 'react';

import { useBreakpoint } from '../../hooks/useBreakpoint';
import { Breakpoint } from '../../utils/breakpoint';
import { useClickOutside } from '../../hooks/useClickOutside';
import { CloseButton } from '../../shared/ui';

export interface IBonusInfoLabelProps {
  text: string;
  onClose?: () => void;
}

export const BonusInfoLabelToolTip: FC<IBonusInfoLabelProps> = ({ text, onClose }) => {
  const breakpoint = useBreakpoint();
  const ref = useRef<HTMLDivElement>(null);
  const paragraphs = useMemo(() => text.split(/\r?\n/).filter((line) => line.trim().length > 0), [text]);

  useClickOutside(ref, onClose, true);

  return (
    <div
      className="relative min-w-[196px] max-w-[220px] lg:min-w-[206px] bg-white lg:max-w-[240px] text-micro rounded-control border-1 p-2 border-primary"
      ref={ref}
    >
      <div className="pr-4 mt-1 whitespace-pre-wrap break-words text-ink-muted text-left">
        {paragraphs.map((line, index) => (
          <p key={`${line}-${index}`} className="mb-1 last:mb-0">
            {line}
          </p>
        ))}
      </div>
      {breakpoint > Breakpoint.Lg && (
        <CloseButton
          size="sm"
          className="absolute top-1 right-1 -m-1"
          onClick={(e) => {
            onClose?.();
            e.stopPropagation();
          }}
        />
      )}
    </div>
  );
};
